import { createRouter, createWebHistory } from "vue-router";

import HomePage from "@/components/HomePage.vue";
import DashboardPage from "@/components/DashboardPage.vue";
import AddInventory from "@/components/AddInventory.vue";
import ItemPage from "@/components/ItemPage.vue";
import SalesPage from "@/components/SalesPage.vue";
import InventoryPage from "@/components/InventoryPage.vue";
import ExpensePage from "@/components/ExpensePage.vue";
import ReportsDashboard from "@/components/ReportsDashboard.vue";
import ProfitLossReport from "@/components/ProfitLossReport.vue";
import InventoryValueReport from "@/components/InventoryValueReport.vue";
import SalesAnalysisReport1 from "@/components/SalesAnalysisReport1.vue";
import SalesChannelReport from "@/components/SalesChannelReport.vue";
import BuyerReport from "@/components/BuyerReport.vue";
import SystemPage from "@/components/SystemPage.vue";
import PlatformPage from "@/components/PlatformPage.vue";
import LicensePage from "@/components/LicensePage.vue";
import AddInventoryWizard from "@/components/addInventory/AddInventoryWizard.vue";

const routes = [
  { path: "/", component: HomePage },
  { path: "/dashboard", component: DashboardPage, meta: { hideDashboardLink: true } },

  // ✅ New main entry point
  { path: "/add-inventory", component: AddInventory },

  // ✅ Optional: keep old URL alive for now so existing nav links don’t break
  { path: "/auctions", redirect: "/add-inventory" },


  { path: "/items", component: ItemPage },
  { path: "/sales", component: SalesPage },
  { path: "/inventory", component: InventoryPage },
  { path: "/expenses", component: ExpensePage },
  { path: "/reports-dashboard", component: ReportsDashboard },
  { path: "/reports/profit-loss", component: ProfitLossReport },
  { path: "/reports/inventory-value", component: InventoryValueReport },
  { path: "/reports/sales-analysis1", component: SalesAnalysisReport1 },
  { path: "/reports/sales-channel", component: SalesChannelReport },
  { path: "/reports/buyer", component: BuyerReport },
  { path: "/system", component: SystemPage },
  { path: "/platforms", component: PlatformPage },
  { path: "/licenses", component: LicensePage },
  { path: "/wizard", component: AddInventoryWizard},
  
  // Optional catch-all
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
